import React from "react";

type Option = { code: string; name: string };

type Props = {
  regions: Option[];
  constituencies?: Option[];
  selectedRegion: string | null;
  selectedConstituency?: string | null;
  onRegionChange: (code: string) => void;
  onConstituencyChange?: (code: string) => void;
};

const KrajObvodFilter = ({
  regions,
  constituencies,
  selectedRegion,
  selectedConstituency,
  onRegionChange,
  onConstituencyChange,
}: Props) => {
  return (
    <div className="v26-filter-card">
      <div className="v26-filter-title">Vybrať obsah</div>
      <div className="v26-filter-row">
        <div className="v26-filter-field">
          <label>Kraj</label>
          <select
            value={selectedRegion ?? "disabled"}
            onChange={(e) => onRegionChange(e.target.value)}
          >
            <option value="disabled" disabled aria-readonly>
              Vybrať kraj
            </option>
            {regions.map((r) => (
              <option key={r.code} value={r.code}>
                {r.name}
              </option>
            ))}
          </select>
        </div>

        {onConstituencyChange && (
          <div className="v26-filter-field">
            <label>Volebný obvod</label>
            <select
              value={selectedConstituency ?? "disabled"}
              onChange={(e) => onConstituencyChange(e.target.value)}
              disabled={!selectedRegion || selectedRegion === "disabled"}
            >
              <option value="disabled" disabled aria-readonly>
                Vybrať volebný obvod
              </option>
              {(constituencies || []).map((c) => (
                <option key={c.code} value={c.code}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>
  );
};

export default KrajObvodFilter;
